<div class="security-dialog">
    <div class="header">
        <span>{{"REQUEST.CONFIRMATION.SECURITY_CODE" | translate}}</span>
        <div class="ic-close" (click)="close()">
            <i class="fal fa-xmark"></i>
            <!--    <mat-icon>{{"GENERAL.CLOSE" | translate}}</mat-icon> -->
        </div>
    </div>
    <div class="content">
        <ng-container
            *ngIf="securityCodeType == securityCodeTypes.Email">{{"REQUEST.CONFIRMATION.CONFIRMATION_HELP_EMAIL" |
            translate}}</ng-container>
        <ng-container *ngIf="securityCodeType == securityCodeTypes.SMS">{{"REQUEST.CONFIRMATION.CONFIRMATION_HELP_SMS" |
            translate}}</ng-container>
        <ng-container
            *ngIf="securityCodeType == securityCodeTypes.TwoFactorAuthentication">{{"REQUEST.CONFIRMATION.CONFIRMATION_HELP_2FA"
            | translate}}</ng-container>
        <form class="recive-code" autocomplete="off">
            <div class="tc-form-field size-md" *ngIf="securityCodeType != securityCodeTypes.TwoFactorAuthentication">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
                    <input matInput [(ngModel)]="userContact" [ngModelOptions]="{standalone: true}" id="input-send-code"
                        [placeholder]="placeHolder | translate" [readonly]="true">
                    <button mat-flat-button class="btn-tc size-sm btn-primary-new send-code" [disableRipple]="true"
                        appMousePress id="sendBtn" [ngClass]="{'is-loading': isSendCodeLoading}"
                        [TcPromise]="sendCodeSubscription" [disabled]="!timeIsExpired || isSendCodeLoading">
                        <span *ngIf="timeIsExpired" (click)="sendCode()">{{'GENERAL.SEND_CODE' | translate}}</span>
                        <tc-countdown-new *ngIf="!timeIsExpired" [leftTime]="interval" (finishedEmit)="onTimerFinished()">
                        </tc-countdown-new>
                    </button>
                </mat-form-field>
            </div>
            <div class="tc-form-field size-md">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field ltr-en-input">
                    <input id="codeInput" [ngModelOptions]="{standalone: true}" matInput [(ngModel)]="securityCode"
                        [maxlength]="verifyCodeLength" [placeholder]="'REQUEST.CONFIRMATION.SECURITY_CODE' | translate"
                        [readonly]="timeIsExpired">
                </mat-form-field>
            </div>
        </form>
    </div>
    <div class="footer">
        <button id="btnCancel" mat-stroked-button class="btn-tc size-sm btn-secondary-new" [disableRipple]="true"
            appMousePress (click)="close()">{{"GENERAL.BACK" |
            translate}} </button>
        <button mat-flat-button class="btn-tc size-sm btn-primary-new" [disableRipple]="true" appMousePress
            [disabled]="!securityCode || securityCode.length<verifyCodeLength" (click)="confirm()">{{"GENERAL.CONFIRM" |
            translate}} </button>

    </div>
</div>